import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { FC, FormEvent } from "react";
import { showError } from "../../Notifications";
import { axiosInstant } from "../../api";
import { message } from "antd";

interface Props {
  submitBtnRef: any;
  planKey?: string;
  amount?: number;
}
const CheckoutForm: FC<Props> = ({ submitBtnRef, planKey, amount }) => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    try {
      const result = await stripe.confirmPayment({
        elements,
        confirmParams: {},
        redirect: "if_required",
      });

      if (result.error) showError(result.error.message);
      else {
        await axiosInstant.post('/subscription/confirm', {
          amount: amount || 0,
          planKey: planKey || 'standerd',
        });
        message.success("Payment successful! A confirmation email has been sent.");
        setTimeout(() => {
          window.location.href = '/';
        }, 1200);
      }
    } catch (err) {
      showError((err as Error).message);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button type="submit" ref={submitBtnRef} style={{ display: "none" }}>
        Submit
      </button>
    </form>
  );
};

export default CheckoutForm;
